import { useQuery } from '@tanstack/react-query';
import subDays from 'date-fns/subDays';
import { useParams } from 'react-router';

import { Button } from 'DesignSystem/ui/button';
import { prefCardsBootstrapQuery } from 'pages/preference-cards/api';
import { useUnSnooze } from 'pages/preference-cards/api/hooks';
import { selectSnoozeBootstrap } from 'pages/preference-cards/api/selectors';
import { getTimeDifferenceByUnit } from 'pages/preference-cards/utils';

type SnoozeNotificationProps = {
  snoozeUntil: string;
  preferenceCardClientItemMasterId: string;
};
export function SnoozeNotification({ snoozeUntil, preferenceCardClientItemMasterId }: SnoozeNotificationProps) {
  const { cardId } = useParams<'cardId'>();
  const { isSuccess, data: snoozeBootstrap } = useQuery(prefCardsBootstrapQuery(selectSnoozeBootstrap));
  const { unSnooze } = useUnSnooze(cardId!);
  if (!isSuccess) return null;
  const diff = getTimeDifferenceByUnit(snoozeBootstrap.defaultSnoozeValue.unit, snoozeUntil, subDays(new Date(), 1));
  return (
    <div className="flex w-full flex-row items-center justify-between rounded-md border border-zinc-400 bg-zinc-100 px-2 font-medium">
      <div>
        Snoozed for {diff} {snoozeBootstrap.defaultSnoozeValue.unit}
        {diff === 1 ? '' : 's'}
      </div>
      <Button variant="link" size="sm" onClick={() => unSnooze(preferenceCardClientItemMasterId)}>
        Remove
      </Button>
    </div>
  );
}

export function InPendingRequestNotification() {
  return (
    <div className="type-body-xs w-full rounded-md border border-yellow-600 bg-yellow-100 px-2 py-1.5 font-medium">
      Item is in a pending request
    </div>
  );
}

export function HasRecommendationsNotification() {
  return (
    <div className="type-body-xs w-full rounded-md border border-yellow-600 bg-yellow-100 px-2 py-1.5 font-medium">
      This item has new quantity recommendations
    </div>
  );
}
